import moment from 'moment';
import { fnComparedValueAndCriterion } from 'utils/logProcessing';

export default function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    rnum: pageIndex * pageSize + index + 1,
    areaNo: d.module.areaNo,
    areaNm: d.module.areaNm,
    modelNm: d.module.modelNm,
    o2: d.o2.toFixed(1),
    hc: d.hc,
    co: d.co,
    co2: d.co2,
    h2s: d.h2s,
    statusCode: d.statusCode,
    status: 'blue',
    battery: d.battery,
    regDate: moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss'),
  };
}
